<app-page-header
  [className]="'mb-1!'"
  [pageTitle]="'Detalles del establecimiento'"
  [showBreadcrumb]="true"
  [backRoute]="`/crm/clientes/${idCliente}`"
  [backQueryParams]="{tab: 1}"
  [backLabel]="'Clientes'"
  [currentRoute]="'Detalle del establecimiento'"
/>

<mat-tab-group [(selectedIndex)]="selectedIndex" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="dark:text-white/90">Cabecera</span>
    </ng-template>
    <ng-template matTabContent>
      <div class="mt-6">
        @if (loading) {
          <app-spinner />
        } @else {
          <app-card
            [title]="'Datos generales'"
            [showEditButton]="permissionAuth.canEdit('clientes')"
            (onEditClick)="editableSwitcher()"
          >
            <app-form [formGroup]="editForm">
              <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
                <div>
                  <app-label for="nombre">
                    Nombre
                  </app-label>
                  <app-input-field id="nombre" formControlName="nombre" />
                </div>

                <div>
                  <app-label for="objetivo">
                    Objetivo
                  </app-label>
                  <app-select id="objetivo" formControlName="objetivo" placeholder="Seleccione un objetivo" [options]="objetivoOptions" />
                </div>

                <div>
                  <app-label for="ubi_zona_id">
                    Zona
                  </app-label>
                  <app-select id="ubi_zona_id" formControlName="ubi_zona_id" placeholder="Seleccione una zona" [options]="zonasOptions" />
                </div>

                <div>
                  <app-label for="pais_nombre">
                    País
                  </app-label>
                  <app-input-field id="pais_nombre" type="text" [value]="paisNombre" disabled readonly />
                </div>

                <div>
                  <app-label for="departamento_nombre">
                    Departamento
                  </app-label>
                  <app-input-field id="departamento_nombre" type="text" [value]="departamentoNombre" disabled readonly />
                </div>

                <div>
                  <app-label for="ciudad_nombre">
                    Ciudad
                  </app-label>
                  <app-input-field id="ciudad_nombre" type="text" [value]="ciudadNombre" disabled readonly />
                </div>

                <div>
                  <app-label for="latitud">
                    Latitud
                  </app-label>
                  <app-input-field id="latitud" formControlName="latitud" />
                  @if (editForm.get('latitud')?.invalid && editForm.get('latitud')?.touched) {
                    <p class="text-error-500 text-sm mt-1">Ingrese una latitud válida entre -90 y 90</p>
                  }
                </div>

                <div>
                  <app-label for="longitud">
                    Longitud
                  </app-label>
                  <app-input-field id="longitud" formControlName="longitud" />
                  @if (editForm.get('longitud')?.invalid && editForm.get('longitud')?.touched) {
                    <p class="text-error-500 text-sm mt-1">Ingrese una longitud válida entre -180 y 180</p>
                  }
                </div>

                <app-location-picker-trigger
                  class="md:col-span-2"
                  [latitud]="editForm.get('latitud')?.value"
                  [longitud]="editForm.get('longitud')?.value"
                  [readOnly]="editable"
                  (coordinatesChange)="onCoordinatesChange($event)"
                />

                <div>
                  <app-label for="km">
                    Kilómetro
                  </app-label>
                  <app-input-field id="km" formControlName="km" type="number" min="0" step="0.1" />
                  @if (editForm.get('km')?.touched && editForm.get('km')?.hasError('min')) {
                    <p class="mt-1 text-sm text-error-500">El kilómetro no puede ser negativo.</p>
                  }
                </div>
              </div>

              <div>
                <app-label for="direccion">
                  Dirección
                </app-label>
                <app-textarea id="direccion" formControlName="direccion" [rows]="2" />
              </div>
            </app-form>
          </app-card>

          <app-edition-buttons *hasPermission="'clientes:edit'"
            [valid]="editForm.valid"
            [process]="loading"
            [editable]="editable"
            [hideEditButton]="true"
            (onEditClick)="editableSwitcher()"
            (onGoBackClick)="goBack()"
            (onCancelClick)="refreshEstablecimiento()"
            (onUpdateClick)="updateEstablecimiento()"
          />
        }
      </div>
    </ng-template>
  </mat-tab>
  <!-- TODO: pestañas ocultas a pedido del cliente. Los contactos del establecimiento
       ahora se gestionan desde la pestaña "Datos de facturación" del cliente. -->
  <!-- <mat-tab>
    <ng-template mat-tab-label>
      <span class="dark:text-white/90">Contactos</span>
    </ng-template>
    <ng-template matTabContent>
      <app-establecimientos-contactos />
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="dark:text-white/90">Servicios</span>
    </ng-template>
    <ng-template matTabContent>
      <app-establecimientos-servicios (onGenerarPresupuesto)="goToPresupuestos($event)" />
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="dark:text-white/90">Presupuestos</span>
    </ng-template>
    <ng-template matTabContent>
      <app-presupuestos [idEstablecimiento]="idEstablecimiento" [idServicioSolicitado]="idServicioSolicitado" />
    </ng-template>
  </mat-tab> -->
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="dark:text-white/90">Animales</span>
    </ng-template>
    <ng-template matTabContent>
      <app-animales [idEstablecimiento]="idEstablecimiento" [idCliente]="idCliente" />
    </ng-template>
  </mat-tab>
</mat-tab-group>
